/* eslint-disable react-hooks/exhaustive-deps */
import { useUserManagement } from './hooks/useUserManagement';

export const UserManagment = () => {
	const { getComponent } = useUserManagement();

	return getComponent();
};
